export enum AccessLevels {
  VIEW_ONLY = 1,
  READ_ONLY = 3,
  READ_WRITE = 5,
  EXTENDED = 6,
  OWNED = 7
}

export enum ContainerNamespace {
  NAMESPACE_PORTFOLIO = 'portfolio',
  NAMESPACE_MONITORING = 'search-alert'
}

export type Container = {
  name: string;
  namespace: ContainerNamespace;
  ownerName: string;
  accessLevel: AccessLevels;
  createdAt: string;
  documentsCount: number;
};
